export const TOGGLE_CARD_VIEW = 'TOGGLE_CARD_VIEW'

export const toggleCardView = () => ({ type: TOGGLE_CARD_VIEW })
